module.exports = __webpack_public_path__ + "static/work01_03-59879c61325e24bac030e417a560f0d7.png";